import React from "react";
import { Box, IconButton } from "@mui/material";
import { EditIcon, HighlightOffIcon, AddCircleOutlineIcon } from "../../../shared/components/icon";
import { useSnackbar } from "../../../shared/context";
import AxiosInstance from "../../../server/AxioInstance";

const iconStyle = {
    fontSize: "2em",  // Ajuste o tamanho conforme necessário
};

const ApproveButton = ({ title, url, item, handleChangeComponent, handleCosnult, edit=true }) => {
    const {showSnackbar} = useSnackbar();

    const handleAction = async (item, type) => {
        const login_user = localStorage.getItem('@gedy:user');
        if(type === 'edit'){
            handleChangeComponent(title, 'edit', item);
        } else {
            const data = {
                id: item.id,
                login_user: login_user,
                type: type, 
            }
            
            try {
                await AxiosInstance.post(url, data, { headers: { "Content-Type": "multipart/form-data" } });
                showSnackbar({
                    vertical: 'top',
                    horizontal: 'right',
                    message: 'Atualizado com Sucesso',
                    variant: 'success',
                });
                handleCosnult();
            } catch (error) {
                showSnackbar({
                    vertical: 'top',
                    horizontal: 'right',
                    message: 'Erro ao enviar a requisição: ' + error.message,
                    variant: 'error',
                });
            }
        } 
    }

    return (
        <Box>
            {edit && <IconButton
                aria-label="edit"
                onClick={() => handleAction(item, 'edit')}
            >
                <EditIcon style={iconStyle} color="primary"/>
            </IconButton>
            }
            {item.active ? (
                <IconButton
                    aria-label="desactive"
                    onClick={() => handleAction(item, 'desactive')}
                >
                    <HighlightOffIcon style={iconStyle} color="error"/>
                </IconButton>
            ):(
                <IconButton
                    aria-label="active"
                    onClick={() => handleAction(item, 'active')}
                >
                    <AddCircleOutlineIcon style={iconStyle} color="success"/>
                </IconButton>
            )}
        </Box>
    );
};

export default ApproveButton;